import { useTranslation } from 'react-i18next';
import { TextLoop } from './ui/text-loop';

const GolfLoadingTips = () => {
  const { t } = useTranslation();
  return (
    <TextLoop className='text-center w-full' interval={3}>
      <span>{t('LoadingTips:filling_ball_basket')}</span>
      <span>{t('LoadingTips:reading_green')}</span>
      <span>{t('LoadingTips:driving_cart')}</span>
      <span>{t('LoadingTips:searching_ball_rough')}</span>
      <span>{t('LoadingTips:ordering_beer')}</span>
      <span>{t('LoadingTips:raking_bunkers')}</span>
      <span>{t('LoadingTips:waiting_previous_group')}</span>
      <span>{t('LoadingTips:repairing_divots')}</span>
      <span>{t('LoadingTips:adjusting_posture')}</span>
      <span>{t('LoadingTips:checking_weather')}</span>
      <span>{t('LoadingTips:placing_tee')}</span>
    </TextLoop>
  );
};

export default GolfLoadingTips;
